module.exports = {"mode":"office","home":{"ambiente":"home","url":"http://localhost"},"office":{"ambiente":"office","url":"http://indicatoriopeninnovation.regione.liguria.it/directus/public"}}


//////////////////
// WEBPACK FOOTER
// ./src/config/url.json
// module id = 340
// module chunks = 0